// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteAlert } from '@esri/calcite-components-react';

interface CalciteAlertWrapperProps
  extends React.ComponentProps<typeof CalciteAlert> {
  onClose?: () => void;
}

const CalciteAlertWrapper = ({
  autoClose,
  icon,
  onClose,
  open,
  ...rest
}: CalciteAlertWrapperProps) => {
  return (
    <CalciteAlert
      autoClose={autoClose || undefined}
      icon={icon || undefined}
      open={open || undefined}
      onCalciteAlertClose={onClose}
      {...rest}
    />
  );
};

export default CalciteAlertWrapper;
